import { useState } from "react";
import {
  UsersUpdateUserPostRequest,
  UsersApi,
  RequestGetSyncItemsStautsRequest,
  ResponseSyncItemsStatusResponse,
} from "../../services/OpenAPI";
import { createConfiguration } from "./common";

export const useApiGetSyncItemsStatus = () => {
  const [result, setResult] = useState<ResponseSyncItemsStatusResponse | null>(
    null
  );
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  // 同期中かどうかと直近の同期結果を返す（取得失敗時は null）
  const getSyncItemsStatus = async (
    req: RequestGetSyncItemsStautsRequest
  ): Promise<ResponseSyncItemsStatusResponse | null> => {
    setIsLoading(true);
    setError(null);

    try {
      setIsLoading(true);
      const config = createConfiguration();
      const request: UsersUpdateUserPostRequest = {
        req,
      };

      const api = new UsersApi(config);
      const response = await api.usersGetSyncItemsStatusPost(request);
      setResult(response);
      return response;
    } catch (err) {
      setError("同期フラグの取得に失敗しました");
      console.error(err);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { getSyncItemsStatus, result, error, isLoading };
};
